import React, { useEffect, useState } from "react";
import { useRef } from "react";

import getLogger from "utils/logger.util.js";
import { CHECKBOX_STATES } from "constants/globalConstants.js";

import AgTable from "components/AgTable";

import { getCIPIndexTableData } from "../AnalyticsHelper/AnalyticsDataParser.js";

import { getCIPIndexTableColDefs } from "./CIPCleaningTable.config.js";

const AnalyticsCIPCleaningTable = ({ analyticsRawData }) => {
  const gridRef = useRef();
  const [colDefs, setColDefs] = useState([]);
  const [tableData, setTableData] = useState([]);
  const Logger = getLogger("AnalyticsCIPCleaningTable");

  useEffect(() => {
    if (analyticsRawData) {
      const formattedData = getCIPIndexTableData(analyticsRawData);
      setTableData(formattedData);
    }
  }, [analyticsRawData]);

  useEffect(() => {
    const headerChkboxState = geColHeaderCheckboxState(tableData);
    const columns = getCIPIndexTableColDefs(headerChkboxState);
    setColDefs(columns);
  }, [tableData]);

  const geColHeaderCheckboxState = sourceList => {
    let state = CHECKBOX_STATES.INDETERMINATE;
    const checkedAlarms = sourceList.filter(cipIndex => Boolean(cipIndex.Display));
    if (checkedAlarms.length === 0) {
      state = CHECKBOX_STATES.UNCHECKED;
    } else if (checkedAlarms.length === sourceList.length) {
      state = CHECKBOX_STATES.CHECKED;
    } else {
      state = CHECKBOX_STATES.INDETERMINATE;
    }
    return state;
  };

  const getGridAPI = () => gridRef?.current?.api;

  const onDisplayChange = () => {
    const itemsToUpdate = getTableData();
    setTableData(itemsToUpdate);
  };

  const getTableData = () => {
    const gridAPI = getGridAPI();
    const updatedTags = [];
    if (gridAPI) gridAPI.forEachNode(node => updatedTags.push(node.data));
    return updatedTags;
  };

  const onColumnSelection = value => {
    const gridAPI = getGridAPI();
    if (gridAPI) {
      const itemsToUpdate = [];
      gridAPI.forEachNodeAfterFilterAndSort(node => {
        const { data } = node;
        data.Display = value;
        itemsToUpdate.push(data);
      });
      gridAPI.applyTransaction({ update: itemsToUpdate });
      setTableData(itemsToUpdate);
    }
  };

  return (
    <>
      <AgTable gridRef={gridRef} rowData={tableData} columnDefs={colDefs} context={{ onDisplayChange, onColumnSelection }} customHeight="350px" />
    </>
  );
};

export default AnalyticsCIPCleaningTable;
